(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-feature-scroll"] && !Shopify.designMode) return;
  try {
    
  class FeatureScroll extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-scroll-container]');
      this.prevButton = this.querySelector('[data-direction="prev"]');
      this.nextButton = this.querySelector('[data-direction="next"]');
      this.items = this.querySelectorAll('.feature-scroll__item');

      if (!this.track || this.items.length === 0) return;

      this.init();
    }

    init() {
      this.attachEventListeners();
      this.updateArrows();
    }

    attachEventListeners() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scroll('prev'));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scroll('next'));
      }

      this.track.addEventListener('scroll', () => this.updateArrows());
      window.addEventListener('resize', () => this.updateArrows());

      // Intersection observer for scroll detection
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setTimeout(() => this.updateArrows(), 200);
            }
          });
        },
        { root: this.track, threshold: 0.5 }
      );

      this.items.forEach((item) => observer.observe(item));
    }

    updateArrows() {
      const scrollLeft = this.track.scrollLeft;
      const scrollWidth = this.track.scrollWidth;
      const clientWidth = this.track.clientWidth;
      const offset = 25;

      if (this.prevButton) {
        if (scrollLeft <= offset) {
          this.prevButton.setAttribute('hidden', '');
        } else {
          this.prevButton.removeAttribute('hidden');
        }
      }

      if (this.nextButton) {
        if (scrollLeft + clientWidth + offset >= scrollWidth) {
          this.nextButton.setAttribute('hidden', '');
        } else {
          this.nextButton.removeAttribute('hidden');
        }
      }
    }

    scroll(direction) {
      const item = this.items[0];
      if (!item) return;

      const itemWidth = item.offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const scrollAmount = itemWidth + gap;

      if (direction === 'next') {
        this.track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      } else {
        this.track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      }

      setTimeout(() => this.updateArrows(), 200);
    }
  }

  customElements.define('feature-scroll', FeatureScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-random-banner"] && !Shopify.designMode) return;
  try {
    
  class RandomBanner extends HTMLElement {
    constructor() {
      super();
      this.banner = this.querySelector('[data-random-banner]');
      this.sectionId = this.banner?.dataset.sectionId;
      this.imageElement = this.banner?.querySelector(`#random-banner-image-${this.sectionId}`);

      const imagesData = this.banner?.dataset.images || '';
      this.images = imagesData ? imagesData.split('|').filter(Boolean) : [];

      this.init();
    }

    init() {
      if (this.images.length > 1 && this.imageElement) {
        this.setRandomImage();
      }
    }

    setRandomImage() {
      const randomIndex = Math.floor(Math.random() * this.images.length);
      const randomImageUrl = this.images[randomIndex];

      if (this.imageElement && randomImageUrl) {
        this.imageElement.src = randomImageUrl;
        this.imageElement.srcset = randomImageUrl;
      }
    }
  }

  customElements.define('random-banner', RandomBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sliding-reviews"] && !Shopify.designMode) return;
  try {
    
  class SlidingReviews extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.sliding-reviews__track');
      this.slides = this.querySelectorAll('.sliding-reviews__slide');
      this.prevBtn = this.querySelector('.sliding-reviews__arrow--prev');
      this.nextBtn = this.querySelector('.sliding-reviews__arrow--next');
      this.indicatorsContainer = this.querySelector('.sliding-reviews__indicators');

      this.currentIndex = 0;
      this.autoplayEnabled = this.track.dataset.autoplay === 'true';
      this.autoplayTime = parseInt(this.track.dataset.autoplayTime) || 5000;
      this.autoplayInterval = null;

      this.init();
    }

    init() {
      this.createIndicators();
      this.attachEventListeners();
      if (this.autoplayEnabled) {
        this.startAutoplay();
      }
    }

    createIndicators() {
      this.slides.forEach((_, index) => {
        const indicator = document.createElement('button');
        indicator.classList.add('sliding-reviews__indicator');
        if (index === 0) indicator.classList.add('sliding-reviews__indicator--active');
        indicator.addEventListener('click', () => this.goToSlide(index));
        this.indicatorsContainer.appendChild(indicator);
      });
    }

    attachEventListeners() {
      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());

      this.track.addEventListener('scroll', () => {
        this.updateCurrentIndex();
      });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => {
        if (this.autoplayEnabled) this.startAutoplay();
      });
    }

    updateCurrentIndex() {
      const slideWidth = this.slides[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      this.currentIndex = Math.round(this.track.scrollLeft / (slideWidth + gap));
      this.updateIndicators();
    }

    updateIndicators() {
      this.indicatorsContainer.querySelectorAll('.sliding-reviews__indicator').forEach((indicator, index) => {
        indicator.classList.toggle('sliding-reviews__indicator--active', index === this.currentIndex);
      });
    }

    goToSlide(index) {
      const slideWidth = this.slides[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      this.track.scrollTo({
        left: index * (slideWidth + gap),
        behavior: 'smooth'
      });
      this.currentIndex = index;
      this.updateIndicators();
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => this.next(), this.autoplayTime);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  customElements.define('sliding-reviews', SlidingReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
